module.exports = __webpack_public_path__ + "static/img/3.9e4c9d5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/4/zh/3.png
// module id = zUqy
// module chunks = 0